import {Centro} from './centro';
import {InventarioEmisiones} from './inventarioemisiones';
import {PlanAccion} from './planaccion';

export class ImportacionPlantilla {
  CENTROS: Centro[];
  INVENTARIO_EMISIONES: InventarioEmisiones[];
  HCO_PLAN_ACCION: PlanAccion[];
}
